import React from "react";

import { useAppSelector } from "store";
import { selectFootfallOverTimeMeasure } from "modules/customer/insights/portfolioNew/footfallNew/footfallNewSlice";
import { FootfallMeasureType } from "modules/customer/insights/portfolioNew/footfallNew/footfallMeasureType";
import { selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { Typography } from "@material-ui/core";

const FootfallOverTimeTitle: React.FC = () => {
    const selectedStore = useAppSelector(selectStore);
    const footfallMeasure = useAppSelector(selectFootfallOverTimeMeasure);
    const measureLabel = footfallMeasure === FootfallMeasureType.NumberOfVisits ? "visits" : "dwell time";

    return (
        <Typography variant="h6" component="div">
            Average monthly {measureLabel} per cell within {selectedStore?.name}'s retail centre
        </Typography>
    );
};

export default FootfallOverTimeTitle;
